import { Button, Typography } from '@breetometer/components';
import { SearchIcon } from 'BreetAssets';

import type { IEmptyState } from './EmptyState.helpers';

const EmptyState = ({ title, description, icon, searchNotFound, clearSearch, isLoading, actionLabel, onAction }: IEmptyState) => (
	<div
		className='empty-state'
		role='status'
	>
		{searchNotFound ? <SearchIcon variant='input-search' /> : icon}
		<div className='empty-state_header'>
			<Typography
				as='h2'
				className='color-neutral-50'
			>
				{searchNotFound ? 'No results found' : title}
			</Typography>
			{isLoading ? <div className='button-spinner' /> : null}
		</div>
		<Typography className='color-primary-50'>
			{searchNotFound ? "Try adjusting your search or filters to find what you're looking for." : description}
		</Typography>
		{!!searchNotFound && !!clearSearch && (
			<Button
				label='Clear search'
				variant='tertiary'
				onClick={clearSearch}
			/>
		)}
		{!searchNotFound && !!onAction && (
			<Button
				label={actionLabel ?? 'Retry'}
				variant='tertiary'
				onClick={onAction}
			/>
		)}
	</div>
);

export default EmptyState;
